// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1gLuELvcIhSs_YAvplbPo0"};